<script lang="ts" setup>
const isActive = ref(false)

function end (element: Element): void {
  (element as HTMLElement).style.height = ''
}

function start (element: Element): void {
  (element as HTMLElement).style.height = `${element.scrollHeight}px`
}

function toggle () {
  isActive.value = !isActive.value
}
</script>

<template>
  <BlockWithBorder class="bg-white !p-0">
    <div
      class="accordion-trigger flex cursor-pointer items-center justify-between"
      :class="{ active: isActive }"
      @click="toggle"
    >
      <slot name="trigger" />
      <SvgIcon :name="isActive ? 'outlined/expand-less' : 'outlined/expand-more'" />
    </div>
    <transition name="accordion" @after-enter="end" @after-leave="end" @before-leave="start" @enter="start">
      <div v-show="isActive" class="accordion-content">
        <div>
          <slot name="content" />
        </div>
      </div>
    </transition>
  </BlockWithBorder>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.accordion-trigger {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2em;
  padding: 20px;
  transition: color 0.3s ease;

  &.active {
    color: variables.$main-blue-color;
  }

  > svg {
    font-size: 24px;
    margin-left: 25px;
  }
}

.accordion-content > div {
  padding: 10px 20px 20px;
}

.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease;
  will-change: height, opacity;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0.01; // Safari (iOS 14) does not register click events on elements with "opacity: 0".
}
</style>
